/** @jsx jsx */
import { jsx, css } from "@emotion/core";

export const FormFieldRow = ({ children }) => (
    <div
        css={css`
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin-top: -12px;
            margin-right: -12px;
            margin-bottom: -12px;
            & > * {
                flex: 1;
                margin-top: 12px;
                margin-right: 12px;
                margin-bottom: 12px;
            }
        `}
    >
        {children}
    </div>
);

const FormField = ({ children, testId, disabled }) => (
    <div
        data-testid={testId}
        css={css`
            display: flex;
            flex-direction: column;
            min-width: 180px;
            ${disabled &&
                css`
                    pointer-events: none;
                    opacity: 0.65;
                `}
        `}
    >
        {children}
    </div>
);

export default FormField;
